module.exports = __webpack_public_path__ + "static/media/frozen8.05e02acf.png";